import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Struct } from './Struct.js';
var getPath = function getPath(object, pathArray) {
  return pathArray.reduce(function (prevObj, key) {
    return prevObj && prevObj[key];
  }, object);
};
export var VersionedStruct = /*#__PURE__*/function (_Struct) {
  _inherits(VersionedStruct, _Struct);
  var _super = _createSuper(VersionedStruct);
  function VersionedStruct(type) {
    var _this;
    var versions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VersionedStruct);
    _this = _super.call(this);
    _this.type = type;
    _this.versions = versions;
    if (typeof type === 'string') {
      _this.versionPath = type.split('.');
    }
    return _this;
  }
  _createClass(VersionedStruct, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var res = this._setup(stream, parent, length);
      if (typeof this.type === 'string') {
        res.version = getPath(parent, this.versionPath);
      } else {
        res.version = this.type.decode(stream);
      }
      if (this.versions.header) {
        this._parseFields(stream, res, this.versions.header);
      }
      var fields = this.versions[res.version];
      if (fields == null) {
        throw new Error("Unknown version ".concat(res.version));
      }
      if (fields instanceof VersionedStruct) {
        return fields.decode(stream, parent);
      }
      this._parseFields(stream, res, fields);
      if (this.process != null) {
        this.process.call(res, stream);
      }
      return res;
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var key, type;
      if (!val) {
        throw new Error('Not a fixed size');
      }
      if (this.preEncode != null) {
        this.preEncode.call(val);
      }
      var ctx = {
        parent: parent,
        val: val,
        pointerSize: 0
      };
      var size = 0;
      if (typeof this.type !== 'string') {
        size += this.type.size(val.version, ctx);
      }
      if (this.versions.header) {
        for (key in this.versions.header) {
          type = this.versions.header[key];
          if (type.size != null) {
            size += type.size(val[key], ctx);
          }
        }
      }
      var fields = this.versions[val.version];
      if (fields == null) {
        throw new Error("Unknown version ".concat(val.version));
      }
      for (key in fields) {
        type = fields[key];
        if (type.size != null) {
          size += type.size(val[key], ctx);
        }
      }
      if (includePointers) {
        size += ctx.pointerSize;
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      var key, type;
      if (this.preEncode != null) {
        this.preEncode.call(val, stream);
      }
      var ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent,
        val: val,
        pointerSize: 0
      };
      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
      if (typeof this.type !== 'string') {
        this.type.encode(stream, val.version);
      }
      if (this.versions.header) {
        for (key in this.versions.header) {
          type = this.versions.header[key];
          if (type.encode != null) {
            type.encode(stream, val[key], ctx);
          }
        }
      }
      var fields = this.versions[val.version];
      for (key in fields) {
        type = fields[key];
        if (type.encode != null) {
          type.encode(stream, val[key], ctx);
        }
      }
      var i = 0;
      while (i < ctx.pointers.length) {
        var ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    }
  }]);
  return VersionedStruct;
}(Struct);